import { Directive, ElementRef, Inject, OnInit, Renderer2 } from '@angular/core';
import { FiItemsListSettings } from '@fi-app/components/items-list/items-list-injectors';
import { ListData } from '@fi-app/components/items-list/list-data.service';
import { ItemsListRowItemBase_data } from '@fi-app/components/items-list/list-row/list-row-item/list-row-item-base';

@Directive({
    selector: '[fi-items-list-name-click]',
    standalone: false,
})
export class FiItemsListNameClickDirective implements OnInit {
    constructor(
        @Inject(FiItemsListSettings) private settings: ListData<any>,
        @Inject(ItemsListRowItemBase_data) private data: any,
        private elementRef: ElementRef,
        private renderer: Renderer2,
    ) {}

    ngOnInit() {
        if (this.settings.CcmListItemNameClick) {
            this.renderer.listen(this.elementRef.nativeElement, 'click', ($event) => {
                this.settings.CcmListItemNameClick($event, this.data);
            });
            this.renderer.setAttribute(this.elementRef.nativeElement, 'role', 'button');
        }
    }
}
